import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, Effect } from '@ngrx/effects';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/exhaustMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';
import { of } from 'rxjs/observable/of';
import { User } from '../../shared/models/user';

import { AuthService } from '../../shared/services/auth.service';
import * as Register from '../actions/register';
import { CodeForm, MinimalRegisterForm } from '../models/register.model';

@Injectable()
export class RegisterEffects {
  @Effect()
  getCode$ = this.actions$
    .ofType(Register.REGISTER_CODE)
    .map((action: Register.RegisterCode) => action.payload)
    .exhaustMap((auth: CodeForm) => {
        return this.authService.getCode(auth)
          .map((user: User) => new Register.RegisterCodeSuccess({user}))
          .catch(error => of(new Register.RegisterCodeFailure(error)));
      },
    );

  @Effect()
  register$ = this.actions$
    .ofType(Register.REGISTER)
    .map((action: Register.Register) => action.payload)
    .exhaustMap((auth: MinimalRegisterForm) => {
        return this.authService.register(auth)
          .map((user: User) => new Register.RegisterSuccess({user}))
          .catch(error => of(new Register.RegisterFailure(error)));
      },
    );

  @Effect({dispatch: false})
  registerCodeSuccess$ = this.actions$
    .ofType(Register.REGISTER_CODE_SUCCESS)
    .do(_ => {
      return this.router.navigate(['/auth/register/email']);
    })

  @Effect()
  registerSendValidationLink$ = this.actions$
    .ofType(Register.REGISTER_SEND_VALIDATION_LINK)
    .exhaustMap(auth => {
        return this.authService.sendEmailVerificationLink()
          .map((user: User) => new Register.RegisterSendValidationLinkSuccess())
          .catch(error => of(new Register.RegisterSendValidationLinkFailure(error)));
      },
    );
/*
  @Effect({dispatch: false})
  registerSuccess$ = this.actions$
    .ofType(Register.REGISTER_SUCCESS)
    .do(_ => {
      return this.router.navigate(['/auth/register/email']);
    })
*/
  @Effect({dispatch: false})
  selectMethodT$ = this.actions$.ofType(Register.REGISTER_SELECT_METHOD)
    .map((code: Register.RegisterSelectMethod) => code.payload)
    .do(codeLink => {
      switch (codeLink) {
        case 'code':
          return this.router.navigate(['/auth/register/code']);
        case 'email':
          return this.router.navigate(['/auth/register/email']);
        case 'contract':
          return this.router.navigate(['/auth/register/contract']);
      }
    });

  constructor(
    private actions$: Actions,
    private authService: AuthService,
    private router: Router,
  ) {
  }
}



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/register/effects/register.effects.ts